<template>
    <transition name="fade">
        <div class="modal is-active" v-show="visible">
            <div class="modal-background" @click="destroy"></div>
            <div class="modal-content">
                <div class="popup-dialog">
                    <div class="popup-title" v-if="title">
                        <h1 class="title is-1">{{ title }}</h1>

                        <div class="popup-close" @click.prevent="destroy">
                            <i class="icon">close</i>
                        </div>
                    </div>

                    <div class="popup-body">
                        <vue-simple-markdown :source="text" v-if="enableMarkdown === true"></vue-simple-markdown>
                        <p v-else>{{ text }}</p>
                    </div>

                    <div class="popup-footer">
                        <a @click.prevent="destroy" href="#" role="button" v-if="cancelOption">{{ this.$t('confirmation_dialog.deny') }}</a>
                        <button @click="confirmation" class="button is-rounded is-success"
                                :class="{'is-loading': this.isLoading}">
                            {{ confirmationButtonText || this.$t('confirmation_dialog.confirm') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        title:          {
            type: String
        },
        text:           {
            type: String,
        },
        onConfirmation: {
            type: Function,
            required: true
        },
        enableMarkdown: {
            type: Boolean,
            default: false
        },
        cancelOption: {
            type: Boolean,
            default: true
        },
        confirmationButtonText: {
            type: String,
            required: false
        }
    },
    data () {
        return {
            isLoading: false
        }
    },
    methods: {
        async confirmation () {
            this.isLoading = true

                this.onConfirmation()
                    .then((data) => {
                        this.$emit('acceptanceSuccessful', data)

                        this.destroy(false)
                    })
                    .catch((data) => {
                        this.$emit('acceptanceFailed', data)
                        this.destroy(false)

                        if (!data?.response?.data?.message) {
                            this.$buefy.toast.open(this.$t('notice.error'))
                        }
                    })
                    .finally(() => {
                        this.isLoading = false
                    })
        }
    }
}
</script>

<style lang="scss">
.modal {
    z-index: 260;
}

.popup-body {
    ul {
        list-style-type: initial;
        padding-left: 2em;
        margin: 1em 0;
    }
}
</style>
